import { generateRequestId } from '../helpers';
import type { BrandingClientSetResponse, BrandingRequest } from '../types';

const DEFAULT_ENDPOINT = '/api/branding/get-branding-set';

export async function fetchBranding(
  request: BrandingRequest,
  endpoint: string = DEFAULT_ENDPOINT
): Promise<BrandingClientSetResponse> {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-mc-date': new Date().toUTCString(),
      'x-mc-req-id': generateRequestId(),
    },
    body: JSON.stringify({ data: [request] }),
  };

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return (await response.json()) as BrandingClientSetResponse;
}
